<template>
	<router-link to="/">
		<div class="back-button">
			<div data-pill> < </div>
			<span data-site>Site {{ restId }}</span>
		</div>
	</router-link>
</template>

<script>
	export default {
		name: 'BackButton',
		computed: {
			restId () {
				return this.$store.getters['alerts/getRestId'];
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import '@/scss/imports.scss';

	div.back-button {
		width: 150px; height: 52px;
		padding: 8px;
		line-height: 36px;
		[data-pill] {
			width: 39px; height: 36px;
			background-color: $bluegreen;
			border-radius: 3px;
			color: white;
			text-decoration: none;
			text-align: center;
			display: inline-block;
		}
		[data-site] {
			padding-left: 10px;
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/ui/BackButton.vue